import React, { Component } from 'react';
import './css/Login.css';
import firebase from '../Firebase.js'
import DB from '../db.js'

class Login extends Component {

	constructor(props) {
		
		super(props);
		this.state = {
			error: this.props.error || false,
			success: this.props.success || false,
			resetPasswordShow: false
		};

		// Bind Allow access by "this" into the function
		this.submitForm = this.submitForm.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
	}
	
	submitForm(e){
		e.preventDefault();
		let state = this.state;
		
		let mail = document.querySelector("#emailLogin").value,
			pass = document.querySelector("#passwordLogin").value

		if(!pass.trim() || !mail.trim()){
			state.error = "Please, try again with different informations."
		}else{
			state.error = null
			this.props.loginData({
				"email": mail,
				"password": pass
			}, () => {
				
			});
		}
		this.setState(state);
	}


	getInfo(){
		let out = {success: false, error: false}
		if(this.state.error)
			out.error = this.state.error
		else if(this.props.error)
			out.error = this.props.error
		else if(this.state.success)
			out.success = this.state.success
		else if(this.props.success)
			out.success = this.props.success

		return (!out.success && !out.error? false : out)
	}

	resetPassword(){
		let self = this,
			success = false,
			error = false,
			mail = document.querySelector("#emailLogin").value


		DB.resetPassword(mail, (e, s) => {
			if(s)
				success = "Success, Please check your mails."
			else
				error = e
			this.setState(Object.assign(this.state, {"success": success, "error": error, "resetPasswordShow": false}))
		})
	}

	render() {
		if(this.props.mustShow){
			let info = this.getInfo()
			console.log(info);
			
			return (
				<div className="d-flex align-items-center justify-content-center flex-column heiht100">
					<div className={ (info? "d-block " + (info.success? "bg-success" : "bg-danger") : "d-none")  + " p-3 mb-4 text-white"}>{info.error || info.success}</div>
					<div className="container w-25 centerCtn">
						<form onSubmit={this.submitForm}>
							<div className="form-group">
								<label htmlFor="exampleInputEmail1">Email address</label>
								<input onKeyUp={(e) => {e.target.value? this.setState(Object.assign(this.state, {resetPasswordShow: true})) : this.setState(Object.assign(this.state, {resetPasswordShow: false}))}} type="email" className="form-control" id="emailLogin" aria-describedby="emailHelp" placeholder="Enter email" autoComplete="on"></input>
								<small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
							</div>
							<div className="form-group">
								<label htmlFor="exampleInputPassword1">Password</label>
								<input type="password" className="form-control" id="passwordLogin" placeholder="Password" autoComplete="on"></input>
							</div>
							<div className="d-flex justify-content-between">
								<button type="submit" className="btn btn-primary">Submit</button>
								<button onClick={this.resetPassword} type="button" className={(this.state.resetPasswordShow? "visible" : "invisible") + " btn btn-info"}>Reset password</button>
							</div>
							</form>
					</div>

				</div>
			);
		}else
			return "";
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/Pages/Login.js